import { render, staticRenderFns } from "./Login-form.vue?vue&type=template&id=16219c85"
import script from "./Login-form.vue?vue&type=script&lang=js"
export * from "./Login-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports